import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, runInAction } from "mobx";
import { Agent } from "../services/agent";
import { ReleaseNote } from "./models/releasenote";

export class ReleaseNoteStore {
	@observable notes: ReleaseNote[] = [];
	@observable loading = false;
	@observable errorMessage: string = null;

	@action async loadNotes(){
		this.loading = true;
		let result = await Agent.ReleaseNotes.get();
		let notes = [];
		result.forEach(note => {
			notes.push(new ReleaseNote(note));
		});
		runInAction(() => {
			this.notes = notes;
			this.loading = false;
		});
	}

	@action async addNote(note){
		this.loading = true;
		await Agent.ReleaseNotes.add(note);
		runInAction(() => {
			this.loading = false;
		});
	}
}



// WEBPACK FOOTER //
// ./src/stores/releasenote-store.ts